// @ts-nocheck
// Sport-dispatch for the scoresheet scan dialogs — shared by the Game Results
// page (UpcomingGamesAdmin) and the division page. `scan` is
// { type: 'basketball' | 'pickleball', game? } | null; the caller owns the
// state and passes the (loaded) division + org. Keep this the ONE place that
// decides which scan UI a sport gets so both pages stay in sync.
import React from 'react';
import helpers from '@/utils/helpers';

import ScoresheetScanBasketball from './ScoresheetScanBasketball';
import ScoresheetScanPickleball from './ScoresheetScanPickleball';

export default function ScoresheetScanDialogs({ scan, division, org, onClose, onSubmitted }) {
  if (!scan || !division) return null;
  const onOpenChange = (v) => { if (!v) onClose && onClose(); };
  if (scan.type === 'basketball' && scan.game) {
    return (
      <ScoresheetScanBasketball
        key={scan.game._id}
        game={scan.game}
        division={division}
        org={org}
        open
        onOpenChange={onOpenChange}
        onSubmitted={onSubmitted}
      />
    );
  }
  if (scan.type === 'pickleball') {
    return (
      <ScoresheetScanPickleball
        key={helpers.getObjId(division)}
        division={division}
        org={org}
        open
        onOpenChange={onOpenChange}
        onSubmitted={onSubmitted}
      />
    );
  }
  return null;
}
